import React, { useState } from 'react';
import { MainButton, SecondaryButton } from './ActionButton';

const ToggleSectionButton = (props) => {
	const [ active, setActive ] = useState(props?.value ?? true);
	const inactive = props?.inactive ?? false;

	const toggle = () => {
		if(!inactive) {
			setActive(!active);
			if(props.onClick != undefined) props.onClick();
		} else {
			if(props.onClickInactive != undefined) props.onClickInactive();
		}
	};

	const classProps = Object.assign({}, { other:'toggle_section_button' }, { ...props._class });
	const button_props = Object.assign({}, {...props}, { onClick:() => toggle(), _class:classProps });

	if(active) {
		return (
			<MainButton
				icon='knk-slide-on'
				color='green'
				{...button_props}
			>{props?.label_on ?? "Unpublish page"}</MainButton>
		)
	}

	return (
		<MainButton
			icon='knk-slide-off'
			color='red'
			{...button_props}
		>{props?.label_off ?? "Publish page"}</MainButton>
	);
}

export default ToggleSectionButton;